import {styled} from "@mui/material";
export const FormattedCountry = styled("span")`
  margin: 0;
font-size: 16px;
font-weight: 600;
line-height: 1.0;
color: #7F56D9;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
`;

export const FlagImage = styled("span")`
display: inline-flex;
        alignItems: center;
        gap: 8px;
        whiteSpace: nowrap;
`;
